export default{
    'CHANGE_USER' (state, payload){
        state.user = payload
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js